
import React, { Component } from 'react';
import List from './List';
import FilterButton from './FilterButton';
import SortButton from './SortButton';
import './FilteredList.css';

class FilteredList extends Component {
  constructor(props) {
    super(props);
    // TODO: Add a new key/value pair in the state to keep track of type
    this.state = {
      search: "",
      results: this.props.items,
      filters: this.props.filters.reduce((map, filter) => {
        return map.set(filter.key, null);
      },
      new Map()),
      sort: (a, b) => a.team.localeCompare(b.team)
    };
  }
  // Sets the state whenever the user types on the search bar
  onSearch = (event) => {
    this.setState({search: event.target.value.trim().toLowerCase()});
  }

  filterItem = (item) => {
    // Checks if the current search term is contained in this item
    // TODO: Add condition to check item’s type
    return item.name.toLowerCase().search(this.state.search) !== -1
      || item.tag.toLowerCase().search(this.state.search) !== -1;
  }
  /* TODO: Add an event handling method for when an item in dropdown is selected
      Per the DropdownButton documentation, this function should take in an eventKey and
      event
  */
  filter = (filterKey, option) => {
    return () => {
      this.setState(prevState => ({
        filters: prevState.filters.set(filterKey, option.filter)
      }));
    }
  }

  sort = (option) => {
    return () => {
      this.setState(prevState => ({
        sort: option.sort
      }));
    }
  }

  renderFilterButtons() {
    return this.props.filters.map(filter => {
      return <li className="filter-list__filters-item" key={filter.title}>
        <FilterButton filter={filter} action={this.filter}>
        </FilterButton>
      </li>
    });
  }

  applyFilter() {
    return Array.from(this.state.filters.values()).reduce((results, filter) => {
      return filter ? results.filter(filter) : results;
    },
    this.state.results.filter(this.filterItem));
  }

  render() {
    return (
      <div className="filter-list">
        <div className="filter-list__nav">
          <div className="filter-list__container">
            <h1 className="filter-list__h1">
              <img className="filter-list__logo" src="logo_large.png" alt="RLCS Logo"/>
            </h1>
            <input className="filter-list__search" type="text" placeholder="Search by name or username" onChange={this.onSearch}/>
            <ul className="filter-list__filters">
              {this.renderFilterButtons()}
            </ul>
          </div>
        </div>
        <div className="filter-list__sort">
          <SortButton sorters={this.props.sorters} action={this.sort}/>
        </div>
        <List items={this.applyFilter().sort(this.state.sort)} />
      </div>
    );
  }
}
export default FilteredList;



// WEBPACK FOOTER //
// ./src/FilteredList.jsx